import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-addclient',
  templateUrl: './addclient.component.html',
  styleUrls: ['./addclient.component.css']
})
export class AddclientComponent implements OnInit {

  hello = true;
  chekuser:any;
  emailid:any;
  sign = 'visibility_off';
  professions = [
    {value: 'Civil Engineer', viewValue: 'Civil Engineer'},
    {value: 'Architect', viewValue: 'Architect'},
    {value: 'Engineer', viewValue: 'Engineer'}
  ];
  constructor(
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar
  ) { }
  addClient: FormGroup;
  regFormData: any;
  ngOnInit() {
    this.addClient = new FormGroup ({
      client: new FormControl('',Validators.required),
      profession: new FormControl('',Validators.required),
      // username: new FormControl('',Validators.required),
      pass: new FormControl('',Validators.required),
      emailid: new FormControl('',[Validators.required, 
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
     
      mobile: new FormControl('',Validators.required),
     
     
     
  })
  }
  back(){
    this.router.navigateByUrl('/register', {skipLocationChange: true}).then(()=>
    this.router.navigate(["mrfd"]));
  }

  onSubmitUser() {
    if (this.addClient.valid) {
      this.authService.registerUser(this.addClient.value).subscribe( (data: any) => {
       this.snackBar.open('Client added successfully ', 'clear', {
        duration: 5000,
      });
        this.regFormData = data;
       // this.addClient.reset();
      //  this.router.navigate(['/logedin']);
      this.router.navigateByUrl('/register', {skipLocationChange: true}).then(()=>
      this.router.navigate(["logedin"]));
       
      }) // {7}
     
    }
  }
  showPassword(input: any): any {
    input.type = input.type === 'password' ?  'text' : 'password';
    if(this.sign == 'visibility_off') {
      this.sign = 'visibility';
    } else {
      this.sign = 'visibility_off';
    }
   }
}
